import { initSentry } from '@/lib/sentry';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialize Sentry before React renders to capture all errors
// This only activates in production (see src/lib/sentry.ts)
initSentry();

createRoot(document.getElementById('root')!).render(<App />);
